import CustomButton from 'components/Buttons/CustomButton'
import PropTypes from 'prop-types'
import { Truck } from 'react-feather'
import { CardText, CardTitle, Modal } from 'reactstrap'
import { formatNumber } from 'helpers'

export default function ModalConfirmTransfer({
  isOpen,
  onClose,
  onConfirm,
  transferData,
  loading = false,
}) {
  const { type, items = [], groups = [], originWarehouse } = transferData || {}
  const isInventory = type === 'INVENTORY'
  const count = isInventory ? items.length : groups.length
  const warehouseName = originWarehouse?.name || originWarehouse?.label || '-'

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered data-testid="modal-confirm-transfer">
      <div className="regular-padding-horizontal small-scrollable-container small-padding-vertical">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
          style={{
            width: 48,
            height: 48,
            backgroundColor: '#EBF3FF',
            color: '#0D6EFD',
          }}
        >
          <Truck size={24} />
        </div>
        <CardTitle className="fw-semibold mb-2">
          Konfirmasi Transfer Inventori
        </CardTitle>
        <CardText className="mb-2" style={{ color: '#475467' }}>
          {isInventory
            ? `Anda akan memindahkan ${count} inventori ke gudang lain.`
            : `Anda akan memindahkan ${count} grup inventori ke gudang lain.`}
        </CardText>

        <div className="p-3 my-2 rounded bg-light border">
          <div className="mb-2">
            <small className="text-muted d-block">Gudang Pengirim:</small>
            <span className="fw-semibold text-dark">{warehouseName}</span>
          </div>

          <div>
            <small
              className="text-secondary fw-semibold d-block mb-1"
              style={{ fontSize: '0.85rem' }}
            >
              {isInventory ? 'Inventori Terpilih:' : 'Grup Terpilih:'}
            </small>
            <div className="d-flex flex-wrap gap-1">
              {isInventory ? (
                items.slice(0, 5).map((item, idx) => (
                  <span
                    key={item.id || idx}
                    className="p-1 px-2 rounded border"
                    style={{
                      fontSize: '0.8rem',
                      fontWeight: 500,
                      backgroundColor: '#EFF8FF',
                      color: '#175CD3',
                      borderColor: '#B2DDFF',
                    }}
                  >
                    {item?.item?.nameItem || item?.nameItem || 'Inventori'}{' '}
                    <span style={{ color: '#175CD3', fontWeight: 400 }}>
                      ({formatNumber(item?.amount || 0)}{' '}
                      {item?.unit || item?.item?.unit || ''})
                    </span>
                  </span>
                ))
              ) : (
                groups.slice(0, 5).map((grp, idx) => (
                  <span
                    key={grp.id || idx}
                    className="p-1 px-2 rounded border"
                    style={{
                      fontSize: '0.8rem',
                      fontWeight: 500,
                      backgroundColor: '#EFF8FF',
                      color: '#175CD3',
                      borderColor: '#B2DDFF',
                    }}
                  >
                    {grp?.label || grp?.name || grp?.nameItem || 'Grup'}
                  </span>
                ))
              )}
              {count > 5 && (
                <span
                  className="p-1 px-2 rounded border"
                  style={{
                    fontSize: '0.8rem',
                    fontWeight: 500,
                    backgroundColor: '#F2F4F7',
                    color: '#344054',
                    borderColor: '#D0D5DD',
                  }}
                >
                  +{count - 5} lainnya
                </span>
              )}
            </div>
          </div>
        </div>

        <small className="text-muted d-block mt-2">
          Anda akan diarahkan ke formulir pengiriman inventori untuk memilih gudang tujuan dan melengkapi data transfer.
        </small>
      </div>

      <div className="regular-padding-horizontal regular-padding-bottom d-flex justify-content-between mt-2">
        <CustomButton
          onClick={onClose}
          outline
          disabled={loading}
          className="fw-semibold btn-cancel"
          style={{ width: '49%', borderColor: '#D0D5DD', color: '#344054' }}
        >
          Batal
        </CustomButton>
        <CustomButton
          onClick={onConfirm}
          disabled={loading}
          className="fw-semibold"
          color="primary"
          style={{ width: '49%' }}
          testId="confirm-transfer-btn"
        >
          {loading ? 'Memproses...' : 'Lanjutkan'}
        </CustomButton>
      </div>
    </Modal>
  )
}

ModalConfirmTransfer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  transferData: PropTypes.object,
  loading: PropTypes.bool,
}
